<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/weier/process/wo/woList" getKey="rows" :columns="columns" :isExpand="true">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('riqi')">
            <yi_time_input :format="'yyyy-MM-dd'" :maxTime="90 * 24 * 3600 * 1000" type="date" :time.sync="yt.conditions.time"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zhichenggongyi')">
            <yi_dictionary_select :clearable="false" :showOptionIds="['02', '03', '04']" :max="8" multiple :type="'MANUFACTURING_PROCESS'" :ids.sync="yt.conditions.manufacturingProcessList"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.conditions.statusList"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="query()" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="resetConditions">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>

      <template #expand="scope">
        <el-table :data="scope.row.bomDTOList" border style="width: 40%" v-if="scope.row.bomDTOList">
          <el-table-column prop="code" :label="$t('chanpinbianma')"> </el-table-column>
          <el-table-column prop="name" :label="$t('chanpinmingcheng')"> </el-table-column>
          <el-table-column prop="spec" :label="$t('guige')"> </el-table-column>
        </el-table>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'screen_printing_management_staff_allocation_order_list',
  data() {
    // 获取今天日期字符串
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;
    return {
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          width: 160
        },
        {
          label: 'jihuadanhao',
          prop: 'plan.no',
          width: 160
        },
        {
          label: 'chanxian',
          prop: 'equipment.name',
          width: 90
        },
        {
          label: 'zhichenggongyi',
          prop: 'manufacturingProcess',
          type: 'dictionary',
          key: 'MANUFACTURING_PROCESS',
          width: 100
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          sort: 'string',
          prop: 'status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },

        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 160
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity',
          sort: 'number',
          width: 110
        },
        {
          label: 'siyinliaohao',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'sucailiaohao',
          prop: 'materialCode'
        },
        {
          label: 'gongwei',
          type: 'header',
          subCols: [],
          width: '500'
        }
      ],
      todayStr // 方便重置按钮用
    };
  },
  methods: {
    query() {
      this.yt.get(1);
    },
    resetConditions() {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 设置为当天0点
      const todayTimestamp = today.getTime();
      this.yt.conditions = {
        time: todayTimestamp,
        orderBy: 'planStartTime,equipmentId asc',
        statusList: ['2', '3', '4'],
        manufacturingProcessList: ['02','03','04']
      };
      this.query();
    }
  },
  created() {
    // 确保页面被正确添加到 router_tabs 中，以便被 keep-alive 包裹
    if (this.$route.meta && this.$route.meta.componentName !== 'screen_printing_management_staff_allocation_order_list') {
      this.$set(this.$route.meta, 'componentName', 'screen_printing_management_staff_allocation_order_list');
    }
    
    // 初始化默认日期和工单状态
    if (!this.yt.conditions.time) {
      this.yt.conditions.time = new Date(); // 让日期组件显示今天
    }
    if (!this.yt.conditions.statusList || this.yt.conditions.statusList.length === 0) {
      this.yt.conditions.statusList = ['2', '3', '4'];
    }

    // 页面加载后自动查询
    setTimeout(() => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 设置为当天0点
      const todayTimestamp = today.getTime();
      this.yt.conditions = {
        time: todayTimestamp,
        statusList: ['2', '3', '4'],
        manufacturingProcessList: ['02','03','04']
      };
      this.query();
    }, 300);

    let dictMap = this.store.state.dictJsonAll['SILK_SCREEN_PRINTING_STATION'];
    let comlumnsTmp = this.utils.copy(this.columns);
    let subCols = [];
    Object.keys(dictMap).forEach(key => {
      subCols.push({ label: dictMap[key], prop: 'subCols.' + key + '' });
    });
    for (let index = 0; index < comlumnsTmp.length; index++) {
      const element = comlumnsTmp[index];
      if (element.label == 'gongwei') {
        comlumnsTmp[index].subCols = subCols;
        this.columns = comlumnsTmp;
        break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

._printContent /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  font-size: 22px;
  color: black;
  padding: 0 10px 0 0;
  box-sizing: border-box;
  font-family: '微软雅黑';
}

._printContent /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: black;
  display: inline-block;
  font-size: 22px;
  outline: none;
  padding: 0 10px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 130px;
  line-height: 25px;
  height: 25px;
  font-family: '微软雅黑';
}
.custom-input-width /deep/ .el-input__inner {
  width: 90px;
}

._printContent /deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 8px;
  line-height: 25px;
}

._printContent /deep/ .el-date-editor,
form .el-input,
form .el-select,
form .el-textarea {
  min-width: 130px;
  width: 100%;
}

._printContent /deep/ .el-input {
  width: 130px;
}

._printContent_long /deep/ .el-input {
  width: 395px;
}

._printContent_long /deep/ .el-input__inner {
  width: 395px;
  line-height: 25px;
  height: 25px;
  font-size: 22px;
  font-family: '微软雅黑';
  color: black;
  background-color: #fff;
  padding: 0 10px;
}

.printFontFamily {
  font-family: '微软雅黑';
}
</style>
<style>
.weier-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}

.standard-print-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}
</style>
